// extracted by mini-css-extract-plugin
export default {"wrapper":"jR","content":"kR","firstSection":"lR","text":"mR","table":"nR","tableText":"oR","row":"pR","column_2":"qR","column_1":"rR","column_3":"sR"};
    if(module.hot) {
      // 1738836197368
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  